package devxertech.com.pages.portfolio.zone

import CommonDivider
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CommonZoneAbout(image: String, title: String, description: String) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = if (breakpoint > Breakpoint.MD)20.px else 0.px)
            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Column(
            modifier = Modifier
                .padding(
                    leftRight = if (breakpoint < Breakpoint.SM) 2.percent else
                        if (window.screen.width >= 1600) 25.percent
                        else 15.percent),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            if (breakpoint >= Breakpoint.MD) {
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .margin(
                            left = when {
                                window.screen.width >= 1600 -> (-20).px
                                window.screen.width >= 1440 -> 310.px
                                window.screen.width in 800..1200 -> 185.px
                                window.screen.width <= 768 -> (-100).px
                                else -> 0.px
                            }
                        ),
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Image(
                        src = image,
                        modifier = Modifier.attrsModifier { attr("alt", "") }.width(56.px).height(50.px)
                    )
                    FieldTitleTextNormalSimple(
                        title,
                        asH2 = true,
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = if (breakpoint <= Breakpoint.LG) 35.px else 40.px,
                        fontWeight = 700,
                        marginTop = (-20).px
                    )
                }
            } else {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier.fillMaxWidth()
                        .margin(
                            left = when {
                                window.screen.width >= 1600 -> (-20).px
                                window.screen.width >= 1440 -> 310.px
                                window.screen.width in 800..1200 -> 185.px
//                                window.screen.width <= 768 -> 20.px
                                else -> 0.px
                            }
                        )
                ) {
                    Image(
                        src = image,
                        modifier = Modifier.attrsModifier { attr("alt", "") }.width(63.px).height(70.px).padding(bottom = 6.px)
                    )
                    FieldTitleTextNormalSimple(
                        title,
                        asH2 = true,
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = 25.px,
                        fontWeight = 700
                    )
                }
            }

            FieldTitleTextNormalSimple(
                text = description,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontWeight = 400,
                fontSize = if (breakpoint <= Breakpoint.LG) 16.px else 20.px,
                textAlign = TextAlign.Start,
                marginLeft = when {
                    window.screen.width >= 1600 -> 50.px
                    window.screen.width >= 1440 -> 210.px
                    window.screen.width in 800..1200 -> 150.px
                    window.screen.width <= 768 -> 10.px
                    else -> 0.px
                }
            )

            Row(
                modifier = Modifier.fillMaxWidth()
                    .gap(if (breakpoint <= Breakpoint.LG) 2.px else 14.px)
                    .padding(top = 10.px, left = if (breakpoint > Breakpoint.MD) 0.px else 0.px)
                    .margin(left = when {
                        window.screen.width >= 1600 -> 90.px
                        window.screen.width >= 1440 -> 410.px
                        window.screen.width in 800..1200 -> 290.px
                        else -> 0.px
                    }),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = if (breakpoint >= Breakpoint.MD) Arrangement.Start else Arrangement.Center
            ) {
                val imageSize = if (breakpoint == Breakpoint.SM || window.screen.width in 300..375) 30.px else 40.px
                val fontSize = if (breakpoint < Breakpoint.SM) 12.px else 16.px

                Image(
                    src = Res.Image.mob_react,
                    modifier = Modifier.attrsModifier { attr("alt", "") }.width(imageSize).height(imageSize).padding(right = 2.px)
                )
                FieldTitleTextNormalSimple(
                    "React",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = fontSize,
                    fontWeight = 400
                )
                CommonDivider(height = 15, width = 1, color = sitePalette.commonSecondaryButtonColor.rgb)
                Image(
                    src = Res.Image.flutter,
                    modifier = Modifier.attrsModifier { attr("alt", "") }.width(imageSize).height(imageSize).padding(right = 2.px)
                )
                FieldTitleTextNormalSimple(
                    "Flutter",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = fontSize,
                    fontWeight = 400
                )
                CommonDivider(height = 15, width = 1, color = sitePalette.commonSecondaryButtonColor.rgb)
                Image(
                    src = Res.Image.python_new,
                    modifier = Modifier.attrsModifier { attr("alt", "") }.width(imageSize).height(imageSize).padding(right = 2.px)
                )
                FieldTitleTextNormalSimple(
                    "Python",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = fontSize,
                    fontWeight = 400
                )
                CommonDivider(height = 15, width = 1, color = sitePalette.commonSecondaryButtonColor.rgb)
                Image(
                    src = Res.Image.android,
                    modifier = Modifier.attrsModifier { attr("alt", "") }.width(imageSize).height(imageSize).padding(right = 2.px)
                )
                FieldTitleTextNormalSimple(
                    "Android",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontSize = fontSize,
                    fontWeight = 400
                )
            }
        }
    }
}
